export function quadToCubic(x1, y1, qx, qy, x2, y2) {
    var r13 = 1 / 3;
    var r23 = 2 / 3;
    return [
        r13 * x1 + r23 * qx, // cpx1
        r13 * y1 + r23 * qy, // cpy1
        r13 * x2 + r23 * qx, // cpx2
        r13 * y2 + r23 * qy, // cpy2
        x2,
        y2, // x,y
    ];
}
//# sourceMappingURL=quad-2-cubic.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/layout/node_modules/@antv/util/esm/path/process/quad-2-cubic.js
// module id = null
// module chunks = 